export const PLAN_EXPIRY_WARNING_DAYS =
  import.meta.env.VITE_PLAN_EXPIRY_WARNING_DAYS || 5;
export const PLAN_EXPIRY_HIDDEN =
  import.meta.env.VITE_PLAN_EXPIRY_HIDDEN === 'true' || false;
